export default __webpack_public_path__ + "static/media/ii.642af107.jpg";